import { Card, Flexbox } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function CastrationsApprovedCard({ castrations }) {
  const { pathname } = useLocation()

  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">Castrações aprovadas por dia</div>
            <cite>
              Últimos 5 dias com registros de castrações aprovadas
              <small> (Castrações canceladas não são consideradas na contagem)</small>
            </cite>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className="fas fa-check" />
          </Flexbox.Column>
        </Flexbox.Columns>
        <div className="divider" />
      </Card.Header>
      <Card.Body>
        {castrations?.length ? (
          <table className="table table-hover table-striped text-small">
            <thead>
              <tr>
                <th width={50} className="text-center">
                  Data
                </th>
                <th width={50} className="text-center">
                  Quantidade de castrações aprovadas
                </th>
              </tr>
            </thead>
            <tbody>
              {Boolean(castrations?.length)
                && castrations.map((row) => (
                  <tr key={row?.dayString}>
                    <td width={50} className="text-center">
                      {row?.dayString}
                    </td>
                    <td width={50} className="text-center">
                      {row?.approved}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>Esta clínica ainda não possui castrações aprovadas</div>
        )}
      </Card.Body>
      <Card.Footer className="text-right">
        <Link
          to={`${pathname}/castrations-approved-by-day`}
          className="btn btn-sm btn-primary"
        >
          <i className="fas fa-folder-open" />
          &nbsp;Ver tudo
        </Link>
      </Card.Footer>
    </Card.Base>
  )
}

CastrationsApprovedCard.propTypes = {
  castrations: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default CastrationsApprovedCard
